controllers.controller('WithdrawWireTransferController', [
    '$scope', '$state', '$stateParams', '$ionicLoading', '$ionicModal', 'LocaleService', 'API', 'ErrorService', 'constants',
    'Validator', 'Storage', 'Utils', 'UserService', 'CountryService',
    function ($scope, $state, $stateParams, $ionicLoading, $ionicModal, LocaleService, API, ErrorService, Const,
              Validator, Storage, Utils, UserService, CountryService) {

        LocaleService.wait().then(function (translation) {
            $scope.translation = translation;
        });

        $scope.user = UserService.get();
        $scope.validator = Validator.getPattern;
        $scope.countries = CountryService.get();
        $scope.constants = Const;
        $scope.withdrawWireTransferBankStateNotRequired = $scope.constants['withdrawWireTransferBankStateNotRequired'];
        $scope.withdraw = { login: $stateParams.login, amount: $stateParams.amount };
        $scope.modal = { actionText: LocaleService.translation.try_again, state: false };
        $scope.withdrawalReasonsTypes = Storage.get('withdrawalReasons')
            .map(function (reason) {
                return {id: reason, label: $scope.translation.withdrawalReason[reason]};
            });
        $scope.reasonModel = {};
        $scope.reasonModel.selectedReason =  null //$scope.withdrawalReasonsTypes.slice(0, 1).pop();

        $scope.countriesModal = function (type, form) {
            $ionicModal.fromTemplateUrl('templates/countries-select.html', {
                scope: $scope,
                hardwareBackButtonClose: false,
                animation: 'slide-in-up'
            }).then(function (modal) {
                $scope.selectType = type;
                $scope.countriesList = $scope.countries;
                $scope.countryModal = modal;
                $scope.countryModal.show();
                $scope.FormController = form;
            });
        };

        $scope.setCountry = function (country) {
            if ($scope.selectType === 'country') {
                $scope.withdraw.country = country.code;
                $scope.countryName = country.country;
                $scope.FormController.bankCountry.$setDirty();
            }
            $scope.search = {};
            $scope.countryModal.hide();
        };

        $scope.closeCountryModal = function () {
            $scope.countryModal && $scope.countryModal.hide();
            $scope.countriesList = null;
        };

        $scope.search = {};

        function checkResponse(data) {
            if (data.status !== 1) {
                throw new ErrorService({
                    source: 'WithdrawWireTransferController',
                    type: Const.error.type.VALIDATION,
                    code: data.code,
                    severity: 'warning',
                    data: {response: data}
                });
            }
            return data;
        }

        $scope.isOtherReason = function() {
            return $scope.reasonModel.selectedReason ?
                $scope.reasonModel.selectedReason.id === 'otherReason' : false; };

        $scope.submit = function (form) {
            Utils.formRevalidate(form);
            if (!form.$valid) return;

            var request = {
                login: parseInt($scope.withdraw.login, 10),
                amount: parseInt($scope.withdraw.amount, 10),
                bankName: $scope.withdraw.bankName,
                bankAccountHolder: $scope.withdraw.accountHolder,
                bankAccountNumber: $scope.withdraw.bankNumber,
                swift: $scope.withdraw.code,
                bankCountry: $scope.withdraw.country,
                bankCity: $scope.withdraw.bankCity || '',
                bankState: $scope.withdraw.bankState || '',
                bankBranch: $scope.withdraw.bankBranch || '',
                bankAddress: $scope.withdraw.bankStreet,
                comment: $scope.withdraw.comment,
                reason: $scope.reasonModel.selectedReason.id || '',
                reasonComment: $scope.reasonModel.reasonDescription || '',
                iban: $scope.withdraw.iban || ''
            };
            $ionicLoading.show();
            console.log({request: request})
            return API.withdrawal(request)
                .then(checkResponse)
                .then(function (response) {
                    $ionicLoading.hide();

                    if(Const.withdrawalComplianceRequired && $scope.user.complianceStatus !== 'approved') {
                        return $state.go('root.app.withdrawCompliance');
                    }

                    $scope.modal.textTitle = LocaleService.translation.messages.withdrawSuccess;
                    $scope.modal.isError = false;
                    $scope.modal.textContent = '';
                    $scope.modal.actionText = LocaleService.translation.continueTrading;
                    $scope.modal.back = 'root.app.withdraw';
                    $scope.modal.state = true;
                })
                .catch(function (error) {
                    $ionicLoading.hide();
                    $scope.modal.textTitle = LocaleService.translation.messages.withdrawalFailed;
                    $scope.modal.actionText = LocaleService.translation.tryAgain;
                    $scope.modal.isError = true;
                    $scope.modal.textContent = LocaleService.translation.messages[error.code] || '';
                    $scope.modal.state = true;
                });
        };

        $scope.$on('$ionicView.afterLeave', function (event) {
            $scope.countryModal && $scope.countryModal.hide() && $scope.countryModal.remove();
        });
    }]);
